import React from 'react';
const testimonials = [{
  stars: 5,
  text: '"De 4 despertares nocturnos a ninguno en 12 días. Como directora de empresa necesitaba un sistema, no consejos. B.E.B.E. 365 me devolvió mis noches y mi productividad."',
  initials: 'LC',
  name: 'Lucía C.',
  location: 'Madrid, España'
}, {
  stars: 5,
  text: '"La sección de estimulación visual es increíble. Mi pediatra no puede creer la coordinación que tiene Mateo a los 5 meses. El protocolo funciona exactamente como promete."',
  initials: 'CA',
  name: 'Carlos A.',
  location: 'Ciudad de México'
}, {
  stars: 5,
  text: '"El único protocolo que mi esposo y yo aplicamos juntos sin conflictos. Salvó nuestra comunicación de pareja y el sueño de toda la familia. Vale 10 veces lo que cuesta."',
  initials: 'ER',
  name: 'Elena R.',
  location: 'Miami, Florida'
}];
export function TestimonialsSection() {
  return <section className="bg-[#FAF7F2] py-16 px-5" data-id="element-251">
      <div className="max-w-[900px] mx-auto" data-id="element-252">
        <div className="text-center mb-2.5" data-id="element-253">
          <span className="inline-block bg-[rgba(183,110,121,0.1)] text-[#B76E79] text-[11px] tracking-widest uppercase px-4 py-1.5 rounded-full font-sans font-bold" data-id="element-254">
            Resultados reales
          </span>
        </div>

        <h2 className="text-3xl md:text-4xl text-[#3D2B1F] mb-4 leading-tight text-center" data-id="element-255">
          Lo Que Dicen los Arquitectos B.E.B.E.
        </h2>

        <p className="text-lg text-[#6B4C3B] text-center max-w-[650px] mx-auto mb-12 italic" data-id="element-256">
          Padres reales. Resultados reales.
        </p>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-257">
          {testimonials.map((testimonial, idx) => <div key={idx} className="bg-white rounded-2xl p-7 shadow-md border border-[rgba(183,110,121,0.1)] transition-transform hover:-translate-y-1" data-id="element-258">
              <div className="text-[#C9A96E] text-lg mb-3.5" data-id="element-259">
                {'★'.repeat(testimonial.stars)}
              </div>
              <p className="text-sm text-[#3D2B1F] italic leading-relaxed mb-4" data-id="element-260">
                {testimonial.text}
              </p>
              <div className="flex items-center gap-3" data-id="element-261">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#B76E79] to-[#C9A96E] flex items-center justify-center text-white font-bold text-base flex-shrink-0" data-id="element-262">
                  {testimonial.initials}
                </div>
                <div data-id="element-263">
                  <div className="text-sm font-bold text-[#3D2B1F]" data-id="element-264">
                    {testimonial.name}
                  </div>
                  <div className="text-xs text-gray-400 font-sans" data-id="element-265">
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}